export function remToPx(rem: number | string) {
  if (typeof rem === 'string') {
    rem = Number(rem.replace(/rem/gi, ''));
  }

  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}
